'use strict';

var _ = require('lodash');
var DtdModalService = function DtdModalService(urdConstants, fileSave, featureToggle) {
  var grid2HepMap = {
    'configuration-user-defined-ref-data-market': urdConstants.HEP_TYPE.MARKET,
    'configuration-user-defined-ref-data-flight': urdConstants.HEP_TYPE.FLIGHT
  };
  var hep2GridMap = _.invert(grid2HepMap);
  function isMarket(type) {
    return type === urdConstants.HEP_TYPE.MARKET;
  }
  function isFlight(type) {
    return type === urdConstants.HEP_TYPE.FLIGHT;
  }
  function getGridId(type) {
    return isMarket(type) ? 'urd-dtd-market-grid' : 'urd-dtd-flight-grid';
  }
  function getParentGridId(type) {
    return hep2GridMap[type];
  }
  function getType(parentGridId) {
    return grid2HepMap[parentGridId];
  }
  function getSaveEventName(type) {
    return isMarket(type) ? 'configuration-urd-market:save' : 'configuration-urd-flight:save';
  }
  function getMarketHeader(data) {
    var marketPOS = featureToggle.isEnabled('SPOS') && data.pos ? '(' + data.pos + ')' : null;
    return [data.market, marketPOS, data.marketProduct, data.demandSeason, data.dowGroup].filter(Boolean).join(' ');
  }
  function getFlightHeader(data) {
    var cabin = data.cabin ? data.cabin + ' Cabin' : null;
    return [data.flightLeg, data.airline, data.flightNumber, cabin, data.season].filter(Boolean).join(' - ');
  }
  function getHeader(type, data) {
    var getHeaderHandler = isMarket(type) ? getMarketHeader : getFlightHeader;
    return getHeaderHandler(data);
  }
  function isNumber(value) {
    return !_.isNaN(value) && _.isNumber(value);
  }
  function validateCell(cell, value) {
    if (value === '' || isNumber(value * 1) && /^[-]?\d+(\.\d{1,5})?$/.test(value)) {
      return true;
    } else {
      return {
        result: false,
        message: 'Field must be numeric, with up to three decimal places.'
      };
    }
  }
  function getCellClassName(rowData, dataField) {
    if (_.has(rowData, '_old')) {
      var oldData = _.isString(rowData._old) ? JSON.parse(rowData._old) : rowData._old;
      if (_.has(oldData, dataField)) {
        return 'rm-jqx-grid-cell-modified';
      }
    }
  }

  /**
   *
   * @param selectedCells
   * @param dataFields
   * @param gridSettings
   * @returns {boolean}
   */
  function shouldStopCellFillDown(selectedCells, dataFields, gridSettings) {
    return selectedCells.length < 2 || dataFields.length > 1 || !gridSettings.jqxGrid('getcolumn', dataFields[0]).editable;
  }

  /**
   *
   * @param gridSettings
   * @param markCellAsEdited
   * @returns {boolean}
   */
  function cellFillDown(gridSettings, markCellAsEdited) {
    var selectedCells = gridSettings.jqxGrid('getselectedcells');
    var dataFields = _.chain(selectedCells).map('datafield').uniq().value();
    var rowIndexes = _.map(selectedCells, 'rowindex');
    var dataField = dataFields[0];
    var value = gridSettings.jqxGrid('getcellvalue', rowIndexes[0], dataField);
    if (shouldStopCellFillDown(selectedCells, dataFields, gridSettings)) {
      return false;
    }
    gridSettings.jqxGrid('beginupdate');
    _.forEach(rowIndexes, function (rowIndex) {
      markCellAsEdited(rowIndex, dataFields, value * 1, gridSettings.jqxGrid('getcellvalue', rowIndex, dataField) * 1);
      gridSettings.jqxGrid('setcellvalue', rowIndex, dataField, value);
    });
    gridSettings.jqxGrid('endupdate');
    gridSettings.jqxGrid('clearselection');
  }

  /**
   *
   * @param data
   * @returns {string}
   */
  function addHeaderRowStyle(data) {
    var position = data.indexOf('</Styles>');
    var headerRow = '<Style ss:ID="s9999"><Alignment ss:Horizontal="Center" ss:Vertical="Bottom"/>' + '<Font ss:Color="#FFFFFF" ss:Bold="1"/><Interior ss:Color="#4A5767" ss:Pattern="Solid"/></Style>\n';
    return [data.slice(0, position), headerRow, data.slice(position)].join('');
  }

  /**
   *
   * @param title
   * @param data
   * @returns {string}
   */
  function addHeaderRowAndItsStyleToExcelData(title, data) {
    var dataWithHeaderStyle = addHeaderRowStyle(data);
    var insertPosition = dataWithHeaderStyle.indexOf('<Row>');
    var headerRow = '<Row><Cell ss:MergeAcross="3" ss:StyleID="s9999"><Data ss:Type="String">' + title + '</Data></Cell></Row>\n';
    return [dataWithHeaderStyle.slice(0, insertPosition), headerRow, dataWithHeaderStyle.slice(insertPosition)].join('');
  }

  /**
   *
   * @param data
   * @param title
   * @param gridId
   */
  function exportDTDToExcel(data, title, gridId) {
    var dataWithAddedElements = addHeaderRowAndItsStyleToExcelData(title, data);
    var fileType = 'application/vnd.ms-excel;charset=UTF-8';
    var fileExtension = 'xml';
    var fileName = fileSave.createFileName(gridId, fileExtension);
    fileSave.createFile(dataWithAddedElements, fileType, fileName);
  }
  return {
    isMarket: isMarket,
    isFlight: isFlight,
    getGridId: getGridId,
    getParentGridId: getParentGridId,
    getType: getType,
    getSaveEventName: getSaveEventName,
    getHeader: getHeader,
    cellFillDown: cellFillDown,
    exportDTDToExcel: exportDTDToExcel,
    validateCell: validateCell,
    getCellClassName: getCellClassName
  };
};
DtdModalService.$inject = ['UrdConstants', 'FileSaveService', 'FeatureToggleService'];
module.exports = DtdModalService;